import { Chip } from '@material-ui/core';
import React, { HTMLProps, useEffect, useState } from 'react';
import { useStyles } from './style';
import WidgetPopup from 'component/popup/customize_popup';
import { WidgetCode } from 'component/popup/constant';
import { AccessFilterType } from './type';
import { RootState, useAppDispatch, useAppSelector } from 'redux/store';
import { setQueryStoreCursor, setSelectedStore } from 'redux/create-style/create-style.slice';

interface IHeaderFilterProps extends HTMLProps<HTMLDivElement> {
    setSearchInput?: any;
    activeIndex?: any;
    setSearchItemsHandler?: any;
    selectedConsumer?: any;
    setSelectedConsumer?: any;
    setTriggerFilter?: any;
}

function ItemFilters(props: IHeaderFilterProps) {
    const classes = useStyles();
    const {
        setSearchInput,
        activeIndex,
        setSearchItemsHandler,
        selectedConsumer,
        setSelectedConsumer,
        setTriggerFilter,
    } = props;
    const dispatch = useAppDispatch();
    const { selectedStore } = useAppSelector((state: RootState) => state.createStyle);
    const [showPopup, setShowPopup] = useState(false);
    const [popupTitle, setPopupTitle] = useState('Search by consumers');
    const [popupWidget, setPopupWidget] = useState<null | WidgetCode>(null);

    const [consumerLabel, setConsumerLabel] = useState(`Consumer's Items`);
    const [storeLabel, setStoreLabel] = useState(`Store's Items`);

    const handleOpenSearchConsumer = () => {
        setShowPopup(true);
        setPopupWidget(WidgetCode.SearchConsumerWidget);
        setPopupTitle(`Search by consumer's name`);
    };

    const handleOpenSearchStore = () => {
        setShowPopup(true);
        setPopupWidget(WidgetCode.SearchStoreWidget);
        setPopupTitle(`Search by store name`);
    };

    const handleLabel = () => {
        if (selectedConsumer) {
            setSearchInput('');
            setConsumerLabel(`${selectedConsumer.fullName}'s Items`);
        } else if (selectedStore) {
            setSearchInput('');
            setStoreLabel(`${selectedStore.name}'s Items`);
        } else {
            setConsumerLabel(`Consumer's Items`);
            setStoreLabel(`Store's Items`);
        }
    };

    useEffect(() => {
        handleLabel();
        // eslint-disable-next-line
    }, [selectedConsumer, selectedStore]);

    return (
        <>
            <div id="header-filter" className={classes.filterWrap}>
                <div className={classes.filter}>
                    <div className={classes.filterSwiperWrapper}>
                        <Chip
                            classes={{
                                outlined: classes.chipOutline,
                                label:
                                    !selectedConsumer && activeIndex === AccessFilterType.PRIVATE
                                        ? classes.chipLabelActive
                                        : classes.chipLabel,
                                icon:
                                    !selectedConsumer && activeIndex === AccessFilterType.PRIVATE
                                        ? classes.chipIconActive
                                        : classes.chipIcon,
                            }}
                            className={
                                !selectedConsumer && activeIndex === AccessFilterType.PRIVATE ? classes.chipActive : ''
                            }
                            label={`My Items`}
                            variant="outlined"
                            onClick={() => setSearchItemsHandler(AccessFilterType.PRIVATE)}
                        />
                        <Chip
                            classes={{
                                outlined: classes.chipOutline,
                                label: selectedStore ? classes.chipLabelActive : classes.chipLabel,
                                icon: selectedStore ? classes.chipIconActive : classes.chipIcon,
                            }}
                            className={selectedStore ? classes.chipActive : ''}
                            label={storeLabel}
                            variant="outlined"
                            onClick={handleOpenSearchStore}
                        />
                        <Chip
                            classes={{
                                outlined: classes.chipOutline,
                                label:
                                    !selectedConsumer && activeIndex === AccessFilterType.PUBLIC
                                        ? classes.chipLabelActive
                                        : classes.chipLabel,
                                icon:
                                    !selectedConsumer && activeIndex === AccessFilterType.PUBLIC
                                        ? classes.chipIconActive
                                        : classes.chipIcon,
                            }}
                            className={
                                !selectedConsumer && activeIndex === AccessFilterType.PUBLIC ? classes.chipActive : ''
                            }
                            label={`Other Stylists' Items`}
                            variant="outlined"
                            onClick={() => setSearchItemsHandler(AccessFilterType.PUBLIC)}
                        />
                        <Chip
                            classes={{
                                outlined: classes.chipOutline,
                                label: selectedConsumer ? classes.chipLabelActive : classes.chipLabel,
                                icon: selectedConsumer ? classes.chipIconActive : classes.chipIcon,
                            }}
                            className={selectedConsumer ? classes.chipActive : ''}
                            label={consumerLabel}
                            variant="outlined"
                            onClick={handleOpenSearchConsumer}
                        />
                        <Chip
                            classes={{
                                outlined: classes.chipOutline,
                                label:
                                    !selectedConsumer && activeIndex === AccessFilterType.ALL
                                        ? classes.chipLabelActive
                                        : classes.chipLabel,
                                icon:
                                    !selectedConsumer && activeIndex === AccessFilterType.ALL
                                        ? classes.chipIconActive
                                        : classes.chipIcon,
                            }}
                            className={
                                !selectedConsumer && activeIndex === AccessFilterType.ALL ? classes.chipActive : ''
                            }
                            label={`All Items`}
                            variant="outlined"
                            onClick={() => setSearchItemsHandler(AccessFilterType.ALL)}
                        />
                    </div>
                </div>
            </div>

            {showPopup && (
                <WidgetPopup
                    titlePopup={popupTitle}
                    widgetCode={popupWidget}
                    listItem={[]}
                    onClose={() => {
                        dispatch(setQueryStoreCursor(null));
                        setTriggerFilter(true);
                        if (selectedConsumer) {
                            dispatch(setSelectedStore(null));
                        }
                        if (selectedStore) {
                            setSearchItemsHandler(null);
                        }
                        setShowPopup(false);
                    }}
                    shortPopup={false}
                    widgetProps={{ selectedConsumer, setSelectedConsumer }}
                />
            )}
        </>
    );
}

export default ItemFilters;
